//Assemblies statistics
// Select all statistics boxes
const boxes = document.querySelectorAll('.statistic__container > .statistic');

// Find the maximum width of the boxes
let maxWidth = 0;

/**
 * handleBoxSizing()
 * Description: A function to address the issue of metric titles being trimmed on the 'About this panel'
 *              page, ensuring they are fully displayed. It adjusts the statistics boxes to have a uniform
 *              width, matching the width of the largest box.
 * Returns: void
 */
const handleBoxSizing = () => {
    boxes.forEach(box => {
        let width = box.offsetWidth;
        if (width > maxWidth) {
            maxWidth = width;
        }
    });

    // Apply the maximum width to all boxes
    boxes.forEach(box => {
        box.style.width = `${maxWidth}px`;
    });
}

addEventListener("load", handleBoxSizing);
addEventListener("resize", handleBoxSizing);


// Toggles the dropdown menu visibility on topic/panel about page.
// When opening, it scrolls the dropdown into view with an offset.
// When closing, it prevents any unwanted scrolling by keeping the current scroll position.

const dropdownToggle = document.getElementById('dropdown-trigger-participatory-space');
const dropdown = document.getElementById('dropdown-menu-participatory-space');

dropdownToggle.addEventListener('click', function () {
    const isOpening = !dropdown.classList.contains('show'); // Check if dropdown is opening
    dropdown.classList.toggle('show');

    if (isOpening) { // Only scroll when opening
        setTimeout(() => {
            const dropdownPosition = dropdownToggle.getBoundingClientRect().top + window.scrollY;
            const offset = 20; // Space above dropdown

            window.scrollTo({
                top: dropdownPosition - offset,
                behavior: 'smooth',
            });
        }, 10); // Small delay to ensure rendering
    } else {
        setTimeout(() => {
            window.scrollTo({
                top: window.scrollY, // Stay at the same position
                behavior: 'instant'
            });
        }, 10);
    }
});


